
  const cardBackURL = "https://cdn.shopify.com/s/files/1/1899/1331/files/Card-back.png?v=1752718357";

const tarotDeck = [
  {
    index: 0,
    name: "The Fool",
    meaning: "New beginnings, spontaneity, adventure",
    insight: "You are at the threshold of something new. Trust in the journey and take a bold step forward with an open heart.",
    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/0-Fool.png?v=1752686485"
  },
  {
    index: 1,
    name: "The Magician",
    meaning: "Manifestation, resourcefulness, power",
    insight: "Everything you need is already within you. Align your will with action — now is the time to bring your vision into reality.",
    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/1-Magician.png?v=1752686483"
  },
  {
    index: 2,
    name: "The High Priestess",
    meaning: "Intuition, mystery, hidden knowledge",
    insight: "There is wisdom within the quiet. Trust what you feel, not just what you see — the truth lies behind the veil.",
    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/2-High_Priestess.png?v=1752686485"
  },
  {
    index: 3,
    name: "The Empress",
    meaning: "Nurturing, abundance, creativity",
    insight: "Growth comes through love, beauty, and connection. Allow yourself to create and nurture what you value.",
    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/3-Empress.png?v=1752686484"
  },
  {
    index: 4,
    name: "The Emperor",
    meaning: "Authority, structure, stability",
    insight: "Now is the time to take control and build a strong foundation. Lead with confidence and stand firm in your power.",
    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/4-Emperor.png?v=1752686485"
  },
  {
    index: 5,
    name: "The Hierophant",
    meaning: "Tradition, wisdom, spiritual guidance",
    insight: "Tradition holds truth, but don’t be afraid to seek your own sacred path. Guidance comes when you listen with openness.",

    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/5-Hierophant.png?v=1752686492"
  },
  {
    index: 6,
    name: "The Lovers",
    meaning: "Love, harmony, choices",
    insight: "Love asks for truth. Whether in union or choice, align with your heart’s deepest values and let them guide your way.",

    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/6-lovers.png?v=1752686495"
  },
  {
    index: 7,
    name: "The Chariot",
    meaning: "Willpower, victory, direction",
    insight: "You have the power to overcome obstacles. With focus and inner balance, move forward — you are the driver of your destiny.",

    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/7-Chariot.png?v=1752686495"
  },
  {
    index: 8,
    name: "Strength",
    meaning: "Courage, inner strength, compassion",
    insight: "Your quiet strength is your greatest ally. Approach challenges with courage and compassion — not force, but presence.",

    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/8-Strength.png?v=1752686498"
  },
  {
    index: 9,
    name: "The Hermit",
    meaning: "Reflection, solitude, inner guidance",
    insight: "Wisdom waits in stillness. Step back to reflect and reconnect with your inner truth — the light you seek is within.",

    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/9-Hermit.png?v=1752686495"
  },
  {
    index: 10,
    name: "The Wheel of Fortune",
    meaning: "Cycles, fate, change",
    insight: "Life is a cycle of highs and lows. Stay centered and open to change — destiny moves with you, not against you.",
    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/10-Wheel_of_Fortune.png?v=1752686501"
  },
  {
    index: 11,
    name: "Justice",
    meaning: "Truth, fairness, law",
    insight: "What is fair will come to light. Speak and act with integrity, for balance and truth are your allies.",

    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/11-Justice.png?v=1752686507"
  },
  {
    index: 12,
    name: "The Hanged Man",
    meaning: "Pause, surrender, new perspective",
    insight: "Pause. Let go of control and see things from a new angle. In surrender, you open space for transformation.",

    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/12-Hanged_Man.png?v=1752686506"
  },
  {
    index: 13,
    name: "Death",
    meaning: "Endings, transformation, release",
    insight: "Let what no longer serves you fall away. This is not an end, but a powerful rebirth in motion.",

    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/13-Death.png?v=1752686507"
  },
  {
    index: 14,
    name: "Temperance",
    meaning: "Balance, harmony, patience",
    insight: "Harmony is found through patience and integration. Blend what feels divided and return to your center.",
    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/14-Temperance.png?v=1752696566"
  },
  {
    index: 15,
    name: "The Devil",
    meaning: "Temptation, materialism, shadow self",
    insight: "Look closely at what holds you. Freedom begins when you recognize what binds you — and choose differently.",
    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/15-Devil.png?v=1752686514"
  },
  {
    index: 16,
    name: "The Tower",
    meaning: "Sudden change, upheaval, revelation",
    insight: "Everything built on shaky ground must fall. Though sudden change can be painful, it clears the way for truth.",
    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/16-Tower.png?v=1752686516"
  },
  {
    index: 17,
    name: "The Star",
    meaning: "Hope, renewal, inspiration",
    insight: "Hope returns like starlight after storm. Reconnect to faith and healing — the universe hasn’t forgotten you.",
    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/17-Star.png?v=1752686518"
  },
  {
    index: 18,
    name: "The Moon",
    meaning: "Illusion, emotion, subconscious",
    insight: "Things are not what they seem. Trust your instincts in the dark — your intuition will guide you through illusion.",
    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/18-Moon.png?v=1752686520"
  },
  {
    index: 19,
    name: "The Sun",
    meaning: "Joy, success, positivity",
    insight: "Joy and clarity are here. Embrace the warmth, celebrate your truth, and let your light shine fully.",
    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/19-Sun.png?v=1752686523"
  },
  {
    index: 20,
    name: "Judgement",
    meaning: "Awakening, reflection, reckoning",
    insight: "You are being called to rise. Reflect, forgive, and awaken to your higher purpose — your past does not define you.",
    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/20-Judgement.png?v=1752686523"
  },
  {
    index: 21,
    name: "The World",
    meaning: "Completion, accomplishment, unity",
    insight: "You’ve come full circle. Celebrate your growth, and step into your next journey with confidence and wholeness.",
    img: "https://cdn.shopify.com/s/files/1/1899/1331/files/21-World.png?v=1752686523"
  }
];

  const positionLabels = ["Past", "Present", "Future"];
  let currentCards = [];

function drawCards(count) {
  const shuffled = [...tarotDeck].sort(() => 0.5 - Math.random());
  const selected = shuffled.slice(0, count);
  const container = document.getElementById("cardContainer");
  const resetContainer = document.getElementById("resetContainer");
  const readingSummary = document.getElementById("readingSummary");

  container.innerHTML = '';
  resetContainer.innerHTML = '';
  readingSummary.innerHTML = '';
  currentCards = [];

  let flippedCount = 0;

  selected.forEach((card, i) => {
    const wrapper = document.createElement("div");
    wrapper.className = "card-wrapper";

    const label = document.createElement("div");
    label.className = "card-label";
    label.innerText = (count === 3 && positionLabels[i]) ? positionLabels[i] : '';

    const cardEl = document.createElement("div");
    cardEl.className = "card";

    const cardInner = document.createElement("div");
    cardInner.className = "card-inner";

    const front = document.createElement("div");
    front.className = "card-face card-front";
    front.innerHTML = `<img src="${cardBackURL}" alt="card back">`;

    const back = document.createElement("div");
    back.className = "card-face card-back";
    back.innerHTML = `<img src="${card.img}" alt="${card.name}">`;

    cardInner.appendChild(front);
    cardInner.appendChild(back);
    cardEl.appendChild(cardInner);

    const content = document.createElement("div");
    content.className = "card-content";
    content.innerHTML = `<strong>${card.name}</strong><br><em>${card.meaning}</em>`;
    content.style.display = "none";

    cardEl.addEventListener("click", () => {
      if (!cardEl.classList.contains("flipped")) {
        document.getElementById("audioChime").play();// 🔔 play chime
        cardEl.classList.add("flipped");
        content.style.display = "block";
        flippedCount++;

        // ✅ Only show summary after all cards are flipped
        if (flippedCount === count) {
          setTimeout(() => {
            if (count === 1) {
              readingSummary.innerHTML = `
                <h2>Your Message</h2>
                <p><strong>${card.name}:</strong> ${card.insight}</p>
              `;
              readingSummary.classList.add('visible'); // ✅ Add this line
            } else if (count === 3) {
              const summaryLines = selected.map((card, i) => {
  const position = positionLabels[i];
  const className = position === "Past" ? "label-past" :
                    position === "Present" ? "label-present" :
                    "label-future";
  return `<p><strong class="${className}">${position}</strong> — <strong>${card.name}</strong>: ${card.insight}</p>`;
}).join('');

              readingSummary.innerHTML = `<h2>Your Reading</h2>${summaryLines}`;
readingSummary.classList.add('visible');

            }
          }, 500); // Delay for polish
        }
      }
    });

    wrapper.appendChild(label);
    wrapper.appendChild(cardEl);
    wrapper.appendChild(content);
    container.appendChild(wrapper);

    currentCards.push({ cardEl, cardInner, front, back, content, card });
  });

  // Add reset button
  resetContainer.innerHTML = `
    <button onclick="shuffleBack()">🔁 Shuffle or Draw Again</button>
  `;
}

function shuffleBack() {
  // 🔊 Play shuffle sound
  document.getElementById("audioShuffle").play();

  // Add shake animation to all cards
  currentCards.forEach(({ cardEl }) => {
    cardEl.classList.add("shake");
  });

  // ⏱ After shake animation ends
  setTimeout(() => {
    // Flip all cards back and hide content
    currentCards.forEach(({ cardEl, content }) => {
      cardEl.classList.remove("flipped");
      cardEl.classList.remove("shake");
      content.style.display = "none";
    });

    // ⏱ Slight delay before redraw
    setTimeout(() => {
      // 🔁 Clear summary now (after shake + flip)
      const readingSummary = document.getElementById("readingSummary");
      readingSummary.innerHTML = '';
      readingSummary.classList.remove('visible');

      drawCards(currentCards.length);
    }, 300);
  }, 400); // match shake duration
}

function resetReading() {
  document.getElementById("cardContainer").innerHTML = '';
  document.getElementById("resetContainer").innerHTML = '';
  document.getElementById("readingSummary").innerHTML = '';
}

